<template>
  <div class="apply">
    <div class="box-card">
      <div class="head">
        <span class="applyTitle">参展商证</span>
        <span class="applyEnd">申请截止时间：2023年9月20日</span>
      </div>

      <div class="introduce">
        <div class="txt">
          <span class="shuoMing">说明</span
          >1、如需要更多参展商证件，请联系展会组委会，咨询电话
          <span class="telNumber">010-84293556</span>
        </div>
        <div class="txt">
          2、根据疫情防控要求，所有进入展馆的参展商须进行实名登记，凭身份证进出展馆。请参展商如实填写现场参展人员信息。
        </div>
        <div class="txt">
          3、展会组委会所收集参展商信息仅用于本届展会现场进出馆使用，不用于其他用途。
        </div>
      </div>
      <!--  表单开始 -->
      <div class="instance">
        <div class="distribution">
          <p class="title">
            <span>分配标准</span>
          </p>

          <div class="tab">
            <table>
              <tbody>
                <!-- 第一行 -->
                <tr class="thead">
                  <th colspan="2" class="standard">标准展位</th>
                  <th>特展展位</th>
                  <th class="notice">备注</th>
                </tr>
                <!-- 第二行 -->
                <tr class="tbody two">
                  <th class="number">9m</th>
                  <th class="number">12m</th>
                  <th rowspan="2" class="txt">
                    4个/24平方米（每满6平方米1个） 最多不超过80个
                  </th>
                  <th rowspan="2" class="beizhu">
                    按照展位面积分配参展证数量，最多不超过80个。超过规定数量，每个需缴纳工本费：20元/个，
                    展会现场增加证件费用为：40元/个
                  </th>
                </tr>
                <!-- 第三行 -->
                <tr class="tbody">
                  <th class="number">3个</th>
                  <th class="number">4个</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--  表单结束 -->

      <div class="run">
        <p class="title">
          <span>分配标准</span>
          <span> <el-button @click="addNew()">新增参展人员</el-button></span>
        </p>

        <div class="runTab">
          <el-table
            :data="table"
            stripe
            style="width: 100%"
            :header-cell-style="{
              background: '#FDC400',
              color: 'rgba(255, 255, 255, 0.85)',
              borderradius: '4px 4px 0px 0px',
            }"
          >
            <el-table-column
              type="selection"
              label="姓名"
              width="54"
            ></el-table-column>
            <el-table-column prop="name" label="姓名" align="center" width="80">
            </el-table-column>
            <el-table-column prop="documentType" label="证件类型" width="120">
            </el-table-column>
            <el-table-column prop="Id" label="身份证号"> </el-table-column>
            <el-table-column prop="companyName" label="单位名称">
            </el-table-column>
            <el-table-column
              prop="boothNumber"
              label="展位号"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column prop="position" label="职务" width="100">
            </el-table-column>
            <el-table-column prop="tel" label="手机" width="180">
            </el-table-column>
            <el-table-column prop="email" label="邮箱" width="140">
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="edit"
                  @click="openEdit(scope.row, scope.$index)"
                  ><i class="el-icon-edit-outline">编辑</i></el-button
                >
                <el-button type="text" @click="deletMsg(scope.$index)"
                  ><i class="el-icon-delete">删除</i></el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="download">
          <div class="item">
            <p>
              如设贵公司参展人员较多，请<span class="template"
                ><a href="#">点击此处下载人员名单模板</a></span
              >
            </p>
            <p>
              <el-upload
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
              >
                <el-button>上传文件</el-button>
              </el-upload>
            </p>
          </div>
          <div class="item sumit">
            <el-button type="primary">提交</el-button>
          </div>
        </div>
      </div>

      <!-- 展品分类说明 -->
    </div>

    <!-- 编辑弹框开始 -->
    <div class="editMsg">
      <el-dialog :visible.sync="editVisible" width="30%" center>
        <span slot="title" class="dialog-footer"> 编辑参展人员信息 </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form :model="editContent" ref="editContent" label-width="124px">
              <el-form-item
                label="姓名："
                prop="name"
                :rules="[{ required: true, message: '姓名不能为空' }]"
              >
                <el-input
                  type="age"
                  v-model="editContent.name"
                  autocomplete="off"
                  placeholder="请输入姓名"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="单位名称："
                prop="companyName"
                :rules="[{ required: true, message: '单位名称不能为空' }]"
              >
                <el-input
                  type="age"
                  v-model="editContent.companyName"
                  autocomplete="off"
                  placeholder="请输入单位名称"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="证件类型："
                prop="documentType"
                :rules="[{ required: true, message: '证件类型不能为空' }]"
              >
                <el-input
                  type="age"
                  v-model="editContent.documentType"
                  autocomplete="off"
                  placeholder="请输入证件类型"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item label="展位号：" prop="boothNumber">
                <el-input
                  type="age"
                  v-model="editContent.boothNumber"
                  autocomplete="off"
                  placeholder="请输入展位号"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item label="职务：" prop="position">
                <span style="width: 100%" v-model="editContent.position">{{
                  editContent.position
                }}</span>
              </el-form-item>

              <el-form-item
                label="手机："
                prop="tel"
                :rules="[{ required: true, message: '手机号码不能为空' }]"
              >
                <el-input
                  type="age"
                  v-model="editContent.tel"
                  autocomplete="off"
                  placeholder="请输入手机"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item label="E-mail：" prop="email">
                <el-input
                  type="age"
                  v-model="editContent.email"
                  autocomplete="off"
                  placeholder="请输入E-mail"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-row class="save"
                ><el-button @click="saveMsg()">保存</el-button></el-row
              >
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 编辑弹框结束 -->

    <!-- 新增弹框开始 -->
    <div class="editMsg">
      <el-dialog :visible.sync="saveVisible" width="30%" center>
        <span slot="title" class="dialog-footer"> 新增参展人员信息 </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form :model="saveContent" ref="saveContent" label-width="124px">
              <el-form-item
                label="姓名："
                prop="name"
                :rules="[{ required: true, message: '姓名不能为空' }]"
              >
                <el-input
                  type="age"
                  v-model="saveContent.name"
                  autocomplete="off"
                  placeholder="请输入姓名"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="单位名称："
                prop="companyName"
                :rules="[{ required: true, message: '单位名称不能为空' }]"
              >
                <el-input
                  type="age"
                  v-model="saveContent.companyName"
                  autocomplete="off"
                  placeholder="请输入单位名称"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="证件类型："
                prop="documentType"
                :rules="[{ required: true, message: '证件类型不能为空' }]"
              >
                <el-input
                  type="age"
                  v-model="saveContent.documentType"
                  autocomplete="off"
                  placeholder="请输入证件类型"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item label="展位号：" prop="boothNumber">
                <el-input
                  type="age"
                  v-model="saveContent.boothNumber"
                  autocomplete="off"
                  placeholder="请输入展位号"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item label="职务：" prop="position">
                <span style="width: 100%" v-model="saveContent.position">{{
                  editContent.position
                }}</span>
              </el-form-item>

              <el-form-item
                label="手机："
                prop="tel"
                :rules="[{ required: true, message: '手机号码不能为空' }]"
              >
                <el-input
                  type="age"
                  v-model="saveContent.tel"
                  autocomplete="off"
                  placeholder="请输入手机"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item label="E-mail：" prop="email">
                <el-input
                  type="age"
                  v-model="saveContent.email"
                  autocomplete="off"
                  placeholder="请输入E-mail"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-row class="save"
                ><el-button @click="sumitAdd()">保存</el-button></el-row
              >
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 新增弹框结束 -->

    <!-- 提示信息 -->
    <div class="noticeMsg">
      <el-dialog :visible.sync="msgVisible" width="30%" center>
        <span slot="title" class="dialog-footer">参展人员等级窗口已经关闭</span>
        <div class="content">
          如变更参展人员信息请致电展会组委会<span>010-84293556</span>
        </div>
        <el-row class="sure"><el-button  @click="msgVisible = false">确定</el-button></el-row>
        <!--  表单结束 -->
      </el-dialog>
    </div>
  <!-- 提示信息结束 -->

    <!-- 提示信息 -->
    <div class="noticeMsg">
      <el-dialog :visible.sync=" overflowVisible" width="30%" center>
        <span slot="title" class="dialog-footer">超出分配数量</span>
        <div class="content">
          请联系展会组委会<span>010-84293556</span>
        </div>
        <el-row class="sure"><el-button  @click=" overflowVisible = false">确定</el-button></el-row>
        <!--  表单结束 -->
      </el-dialog>
    </div>
  <!-- 提示信息结束 -->

  </div>
</template>
<script>
export default {
  data() {
    return {
      flag: false,
      //文件上传下载
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],

      table: [
        {
          name: "张三",
          documentType: "身份证",
          Id: "10134319904145611",
          companyName: "中国煤炭工业国际技术咨询有限责任公司",
          boothNumber: "W0001",
          position: "会展部经理",
          tel: "13812345678",
          email: "123@qq.com",
        },
        {
          name: "李四",
          documentType: "身份证",
          Id: "10134319904145611",
          companyName: "中国煤炭工业国际技术咨询有限责任公司",
          boothNumber: "W0001",
          position: "技术部经理",
          tel: "13812345678",
          email: "123@qq.com",
        },
      ],

      //编辑弹框标志位
      editVisible: false,
      //编辑弹框的具体内容
      editContent: {
        name: "",
        companyName: "",
        documentType: "",
        Id: "",
        boothNumber: "",
        position: "",
        tel: "",
        email: "",
      },
      //保存弹框的具体内容
      saveVisible: false,
      //保存弹框的具体内容
      saveContent: {
        name: "",
        companyName: "",
        documentType: "",
        Id: "",
        boothNumber: "",
        position: "",
        tel: "",
        email: "",
      },
      //登记窗口关闭提示信息
      msgVisible: true,
	  //超出份额提示
       overflowVisible: true,



    };
  },
  methods: {
    //文件上传移除相关钩子函数
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //编辑弹框相关函数
    //打开编辑框
    openEdit(row, index) {
      this.editContent = row;
      this.editVisible = true;
      console.log(index);
    },
    //取消关闭编辑框
    closeEdit() {
      this.editVisible = false;
    },
    //编辑保存函数
    saveMsg() {
      this.editVisible = false;
    },
    //表格数据删除
    deletMsg(index) {
      this.table.splice(index, 1);
    },
    //打开新增弹框
    addNew() {
      this.saveContent = {};
      this.saveVisible = true;
    },
    //保存
    sumitAdd() {
      this.saveVisible = false;
    },

  },
};
</script>

<style scoped lang="scss">
.apply {
  padding: 17px 26px;
  box-sizing: border-box;
  background: #f0f2f5;
  .box-card {
    width: 100%;
    border-radius: 2px;
    background: #ffffff;
    .head {
      padding: 17px 0px;
      border-bottom: 1px solid #e8e8e8;
      .applyTitle {
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin-left: 26px;
      }
      .applyEnd {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        margin-left: 17px;
      }
    }
    //说明
    .introduce {
      margin: 26px 17px 0px 17px;
      padding-bottom: 9px;
      background: #f6f6f7;
      .txt {
        padding-left: 65px;
        box-sizing: border-box;
        position: relative;
        padding-top: 9px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        .shuoMing {
          position: absolute;
          top: 9px;
          left: 26px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff190c;
        }
        .telNumber {
          color: #006fb8;
        }
      }
    }
    .instance {
      margin: 35px 17px 0px 17px;

      .distribution {
        .title {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          padding-bottom: 9px;
          border-bottom: 1px solid #e9e9e9;
        }
        .tab {
          margin-top: 9px;
          table {
            border-collapse: collapse;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            border-radius: 3px 3px 0px 0px;
            height: 36px;
            width: 100%;
            tbody {
              border: 1px solid #e8e8e8;
              .thead {
                height: 36px;
                background: #006fb8;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.85);
                line-height: 19px;
                .notice {
                  text-align: left;
                  padding-left: 45px;
                }
              }
              .tbody {
                .number {
                  border: 1px solid #e8e8e8;
                  height: 60px;
                  width: 120px;
                }
                .txt {
                  padding: 0px 85px;
                  box-sizing: border-box;
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                }
                .beizhu {
                  padding: 0px 45px;
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
    .run {
      margin: 35px 17px 0px 17px;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        padding-bottom: 9px;
        border-bottom: 1px solid #e9e9e9;
        display: flex;
        justify-content: space-between;
        .el-button {
          width: 100px;
          height: 28px;
          line-height: 0px;
          padding: 0px;
          position: relative;
          top: 3px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
      .runTab {
        margin-top: 10px;
      }
      .download {
        .item {
          margin-top: 17px;
          display: flex;
          justify-content: flex-start;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;

          p {
            line-height: 28px;
          }
          .upload-demo {
            margin-left: 52px;
          }
          .template {
            a {
              color: #006fb8;
            }
          }
        }
      }
    }
  }
  .editMsg {
    //编辑框的弹框信息
    .dialog-footer {
      width: 100%;
      position: relative;
      top: -5px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      //标题
      .instance {
        margin: 0px 17px 0px 17px;
        .title {
          padding: 35px 0px 9px 0px;
          border-bottom: 1px solid #e9e9e9;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
        .txt {
          margin-top: 17px;
          padding-left: 65px;
          box-sizing: border-box;
          position: relative;
          padding-top: 9px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          height: 36px;
          background: #f6f6f7;
          .shuoMing {
            position: absolute;
            top: 9px;
            left: 26px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff190c;
          }
        }
        .content {
          width: 50%;
          margin: 0 auto;
          margin-top: 35px;
          position: relative;
          left: -40px;
          .telNumber {
            color: #006fb8;
            margin-left: 5px;
          }
          .numberV {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 19px;
            letter-spacing: 1px;
            .remaining {
              color: #ff190c;
            }
          }
        }
        //展品信息分类
        .box {
          width: 60%;
          position: relative;
          left: 161px;
          //每一项开始
          .item {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .left {
              width: 107px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 19px;
              text-align: right;
              padding-right: 17px;
              padding-top: 10px;
              box-sizing: border-box;
            }
            .right {
              flex: 1;
              position: relative;
              .twoTitle {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .folding {
                position: absolute;
                right: 30px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
              }
            }
          }

          //每一项结束
        }
        .bottom {
          width: 60%;
          position: relative;
          left: 161px;
          .btn {
            margin-top: 22px;
            margin-bottom: 30px;
            .why {
              margin-left: 120px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ff190c;
              margin-bottom: 22px;
              a {
                margin-left: 10px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #006fb8;
              }
            }
          }
        }
      }
    }
  }

  .noticeMsg {
    //编辑框的弹框信息
    

   

    .dialog-footer {
  
   
      height: 36px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      text-align: left;
     
    }
    .content {
      border-bottom: 1px solid #00000017;
      padding-bottom: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
	  span{
		    color: #006fb8;
		   padding-left: 5px;
	  }
    }
	.sure{
	display: flex;
	justify-content: flex-end;
    padding-top: 10px;

}
  }
}
</style>
<style scoped>
.el-table >>> th {
  padding: 0px !important;
  height: 36px;
}
.upload-demo >>> .el-button {
  width: 93px;
  height: 28px !important;
  padding: 0px;
}
.sumit >>> .el-button {
  margin-top: 10px;
  width: 76px;
  height: 28px;
  background: #006fb8;
  padding: 0px;
  margin-bottom: 163px;
}

[class*=" el-icon-"],
[class^="el-icon-"] {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #006fb8;
  line-height: 20px;
  margin: 0px 8px;
}
.edit {
  border-right: 1px solid #e9e9e9;
}

.runTab >>> .el-button {
  padding: 0px;
  border-radius: 0px;
}

.runTab >>> .el-button + .el-button {
  margin-left: 0px;
}
.el-dialog__wrapper >>> .el-dialog__header {
  background: #006fb8;
      display: flex;
    justify-content: space-between;
}
.save {
  overflow: hidden;

  position: relative;
  display: flex;
  justify-content: center;
}
.save >>> .el-button {
  padding: 0px;
  width: 30%;
  height: 35px;
  text-align: center;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.sure{
	display: flex;
	justify-content: flex-end;
    padding-top: 10px;
}
.sure >>> .el-button {
  padding: 0px;
  width: 65px;
  height: 32px;
  background: #006fb8;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.noticeMsg >>>.el-dialog__body{
	 padding-bottom: 10px;
}
.apply >>> .el-dialog__close{
	color: #FFFFFF;
}
</style>
